import React from 'react'
import { SelectInput, SelectInputProps } from 'react-admin'
import LocalizedFieldWithChoices from './LocalilzedFieldWithChoices'

type Props = Omit<SelectInputProps, 'disabled'> & {
  forceDisabled?: boolean
}

const LocalizedSelectInput: React.FC<Props> = ({
  forceDisabled = false,
  ...props
}) => (
  <LocalizedFieldWithChoices {...props} disabled={forceDisabled}>
    <SelectInput />
  </LocalizedFieldWithChoices>
)

export default LocalizedSelectInput
